<template>
	<div class="container">
		<ul class="down-list clearfix">
			<li v-if="!userId">
				<router-link to="/login"><img src="@/assets/down_01.png"/></router-link>
			</li>
			<li v-else><a @click="getFile(attachTask)"><img src="@/assets/down_01.png"/></a></li>
			<li v-if="!userId">
				<router-link to="/login"><img src="@/assets/down_02.png"/></router-link>
			</li>
			<li v-else><a @click="getFile(attachTest)"><img src="@/assets/down_02.png"/></a></li>
			<li v-if="!userId">
				<router-link to="/login"><img src="@/assets/down_03.png"/></router-link>
			</li>
			<li v-else><a @click="getFile(attachAdaptation)" ><img src="@/assets/down_03.png"/></a></li>
		</ul>
		<div class="sort-wrap">
			<h6>排序方式</h6>
			<div class="sort-item">
				<span :class="{'sort-item-active':sortType==0}" @click="toSort(0)">按分值</span>
				<span class="sort-line"></span>
				<span :class="{'sort-item-active':sortType==1}" @click="toSort(1)">按完成</span>
				<span class="sort-line"></span>
				<span :class="{'sort-item-active':sortType==2}" @click="toSort(2)">按时间</span>
			</div>
		</div>
		<ul class="bgwhite">
			<li :class="{'task-list': true, 'task-active': currentIndex==index}" v-for="(item, index) in dataList" :key="item.id">
				<div class="task-title"  @click="showDetail(item,index)">
					<h3>{{item.taskName}}</h3>
					<!-- 任务状态 0已领取  1已提交 2已撤销  3审核中   4审核不通过  5审核通过(任务完成)   -->
					<span class="task-score">{{item.integralNum}}分</span>
					<div class="task-status">
						<span v-if="item.enrollStatus==0||item.enrollStatus==2" class="yellow">已领取</span>
						<span v-if="item.enrollStatus==1">已提交</span>
						<span v-if="item.enrollStatus==3" class="gray">审核中</span>
						<span v-if="item.enrollStatus==4" class="gray">未通过审核</span>
						<span v-if="item.enrollStatus==5&&item.answerType==1">已完成</span>
						<span v-if="item.enrollStatus==5&&item.answerType==2">已提交（可多次提交）</span>
					</div>
				</div>
				<div class="task-guide" v-if="index==currentIndex">
					<div class="task-total-score" v-if="item.enrollStatus==5&&item.answerType==1">
						本任务获得
						<span class="colorred2">{{item.enrollIntegralNum}}分</span>
					</div>
					<div class="task-total-score" v-if="item.enrollStatus==5&&item.answerType==2">
						最近一次任务获得
						<span class="colorred2">{{item.enrollIntegralNum}}分</span>
					</div>
					<h3 class="task-guide-title">{{item.taskName}}</h3>
					<ul class="guide-list">
						<li v-html="item.content"></li>
						<!-- <li v-if="item.enrollStatus==4" class="colorred2">未通过审核原因：</li>
						<li class="min-height" v-if="item.enrollStatus==5||item.enrollStatus==4" v-html="item.auditComment"></li> -->
						<!-- <li>
							<h6>1. 安装向导</h6>
							<p>验证直接安装和试用模式下界面上的相关要素是否符合易理解性、功能是否正常。</p>
						</li> -->
						<li>
							<!-- <textarea v-if="item.enrollStatus==5||item.enrollStatus==4" disabled v-model="item.auditComment" class="task-desc colorred2"></textarea> -->
							<!-- <textarea v-model="taskDesc" disabled class="task-desc" placeholder="请将任务完成步骤及结果以附件的形式进行上传，审核结果将在此进行反馈"></textarea> -->
							<div v-if="item.enrollStatus==5||item.enrollStatus==4" class="task-desc" v-html="item.auditComment"></div>
							<div v-else class="task-desc">请将任务完成步骤及结果以附件的形式进行上传，审核结果将在此进行反馈</div>
						</li>
						<li>
							<div class="btns-two clearfix">
								<span v-if="(!item.enrollStatus&&item.enrollStatus!=0)" class="yellow" @click="getTask(item)">领取任务</span>
								<span v-if="item.enrollStatus==0||item.enrollStatus=='2'||item.enrollStatus=='4'" class="green" @click="submitTask(item,index)">提交任务</span>
								<span v-if="item.enrollStatus==1&&item.answerType==1" class="green" @click="revokeTask(item,index)">撤销任务</span>
								<span v-if="item.enrollStatus==5&&item.answerType==1" class="disabled">完成</span>
								<span v-if="item.enrollStatus==3&&item.answerType==1" class="disabled" @click="checking">审核中</span>
								<span v-if="(item.enrollStatus==1&&item.answerType==2)||(item.enrollStatus==3&&item.answerType==2)||(item.enrollStatus==5&&item.answerType==2)" class="green" @click="submitTaskAgain(item,index)">再次提交</span>
								<el-upload
								v-if="(item.enrollStatus==5&&item.answerType==1)||(item.enrollStatus==3&&item.answerType==1)||item.enrollStatus==1&&item.answerType==1||!userId||(!item.enrollStatus&&item.enrollStatus!=0)"
								class="upload-demo"
								:ref="'uploadRef'+index"
								:action="uploadUrl"
								:limit="1"
								:on-success="(res)=>handleSuccess(res, index)"
								disabled
								:on-error="handleError">
									<span class="disabled">上传附件</span>
								</el-upload>
								<el-upload
								:ref="'uploadRef'+index"
								v-else
								class="upload-demo"
								:action="uploadUrl"
								:file-list = 'uploadFileList'
								:limit="1"
								accept=".doc,.docx,.wps,.xls,.xlsx,.txt,.rtf,.pdf,.bmp,.gif,.jpg,.pic,.png,.tif,.rar,.zip,.arj,.gz,.z"
								:on-success="(res,fileList)=>handleSuccess(res,fileList,index)"
								:on-exceed="handleExceed"
								:on-preview="handlePreview"
								:on-remove="handleRemove"
								:before-upload="beforeUpload"
								:on-error="handleError">
									<span>上传附件</span>
								</el-upload>
							</div>
						</li>
						<li v-if="item.fileId||item.fileList&&item.enrollStatus!=2" style="width:512px; margin:-25px auto 0; padding-bottom: 20px">
							<ul class="el-upload-list el-upload-list--text" v-if="item.answerType==1">
								<li class="el-upload-list__item is-success" style="padding-bottom:0">
									<a class="el-upload-list__item-name" @click="getFile(item.fileId)">
										<i class="el-icon-document"></i> {{item.fileName}}
									</a>
									<label class="el-upload-list__item-status-label"><i class="el-icon-upload-success el-icon-circle-check"></i></label>
									<i class="el-icon-close" v-if="item.enrollStatus==4" @click="deleteFile(item)"></i>
								</li>
							</ul>
							<ul class="el-upload-list el-upload-list--text" v-else-if="item.answerType==2">
								<li class="el-upload-list__item is-success" style="padding-bottom:0" v-for="(fileItem) in item.fileList" :key="fileItem.id">
									<a class="el-upload-list__item-name"  @click="getFile(fileItem.id)">
										<i class="el-icon-document"></i> {{fileItem.fileName}}
									</a>
									<label class="el-upload-list__item-status-label"><i class="el-icon-upload-success el-icon-circle-check"></i></label>
									<i class="el-icon-close" v-if="item.enrollStatus==4" @click="deleteFile(item)"></i>
								</li>
							</ul>
						</li>
					</ul>
				</div>
			</li>
			<ContentNo content="暂时没有相关任务" v-if="dataList.length<=0"/>
		</ul>
		<div class="page-size">
			<el-pagination
			background
			@current-change="handleCurrentChange"
			:page-size= this.pageSize
			layout="prev, pager, next"
			hide-on-single-page
			:total= this.total>
			</el-pagination>
		</div>
		<el-dialog title="温馨提示" :visible.sync="dialogVisible">
			<div>
				<div v-html="ruleContent"></div>
				<div class="rule-tips">
					<!-- <el-radio-group v-model="radioDialog">
						<el-radio label="0" click.native.prevent="clickitem">下次不再提示任务规则说明</el-radio>
					</el-radio-group> -->
					<el-radio-group v-model="radioDialog1" v-if="codeId==1">
						<el-radio v-for="item in checkList" :key="item.id" :label="item.id"  @click.prevent.native="changeRadioDialog(item.id)">{{item.name}}</el-radio>
					</el-radio-group>
					<el-radio-group v-model="radioDialog2" v-if="codeId==2">
						<el-radio v-for="item in checkList" :key="item.id" :label="item.id"  @click.prevent.native="changeRadioDialog(item.id)">{{item.name}}</el-radio>
					</el-radio-group>
					<el-radio-group v-model="radioDialog3" v-if="codeId==3">
						<el-radio v-for="item in checkList" :key="item.id" :label="item.id"  @click.prevent.native="changeRadioDialog(item.id)">{{item.name}}</el-radio>
					</el-radio-group>
				</div>
				<div class="btns-single" @click="closeDialog('dialogVisible')">关 闭</div>
			</div>
		</el-dialog>
		<el-dialog title="温馨提示" width="30%" :visible.sync="getTaskDialog">
			<div class="dialog-wrap" style="margin-top: -10px">
				<p>领取任务成功！请您在规定时间内提交任务结果！</p>
				<div class="btns-single" @click="closeDialog('getTaskDialog')">关闭</div>
			</div>
		</el-dialog>
		<el-dialog title="温馨提示" width="30%" :visible.sync="submitTaskDailog">
			<div class="dialog-wrap">
				<p>任务提交成功！请您耐心等待任务审核结果，首次提交后的24小时内，您可以撤销任务结果；提交24小时之后则不能撤销。您也可以前往任务专区继续领取新任务哦。</p>
				<div class="btns-single" @click="closeDialog('submitTaskDailog')">关闭</div>
			</div>
		</el-dialog>
		<el-dialog title="温馨提示" width="30%" :visible.sync="checkingDialog">
			<div class="dialog-wrap">
				<p>任务结果正在审核中，请您耐心等待任务审核结果，您也可以前往任务专区继续领取新任务哦。</p>
				<div class="btns-single" @click="closeDialog('checkingDialog')">关闭</div>
			</div>
		</el-dialog>
  </div>
</template>

<script>
import qs from 'qs'
import {post, config, ajaxParam} from '../../../../units/request.js'
import ContentNo from '../../../../components/contentno'
export default {
  name: 'TaskList',
  components: {
    ContentNo
  },
  data(){
	return{
		dialogVisible: true,
		getTaskDialog: false,
		submitTaskDailog: false,
		checkingDialog: false,
		sortType: 0,  //排序类型  0 按分 1按完成度
		sortFlag: 0, //0正序  1倒序
		dataList: [],
		currentIndex: -1,
		codeId: 1,
		ruleContent: '',
		radioDialog1: '1',
		radioDialog2: '1',
		radioDialog3: '1',
		radioArray: [],
		taskDesc: '',//任务描述
		fileUrl: '',//上传文件地址
		fileId: '', //上传文件id
		attachAdaptation: '',
		attachTask: '',
		attachTest: '',
		checkList:[{id:10, name:'下次不再提示任务规则说明'}],
		isProcess: false,
		pageNum: 1,
		pageSize: 10,
		total: 0,
		uploadUrl: '',
		uploadFileList:[],
		uploadRef: 'uploadRef'
	}
  },
  methods: {
	clickitem(){
		this.radioDialog = this.radioDialog=='1'?'0':'1'
	},
	toSort(type){
		if(this.sortType==type){
			this.sortFlag = this.sortFlag==0?1:0
		}
		this.sortType = type
		this.dataList = []
		this.pageNum = 1
		this.currentIndex = -1
		//按不同类型排序，0按分值 1按完成  2按时间
		this.getDataList()
	},
	//获取任务列表
	async getDataList(){
		let url = 'v1/activityTask/getTaskList'
		let code = ''
		if(this.codeId==1) {
			code = 'XUANSHANG'
		} else if(this.codeId==2) {
			code = 'CESHI'
		} else if(this.codeId==3){
			code = 'SHIPEI'
		}
		let param = {
			activityId: this.activityId,
			userId: this.userId,
			code: code,
			sortType: this.sortType,
			sortFlag: this.sortFlag,
			pageSize: this.pageSize,
			pageNum: this.pageNum
		}
		ajaxParam(param)
		const res = await post(url, qs.stringify(param))
		if(res.data.code==200) {
			this.dataList = res.data.list
			res.data.list.forEach(item=>{
				if(item.enrollStatus==4) {
					this.taskDesc = item.enrollContent
					this.taskId = item.fileId
					// this.fileUrl = item.fileUrl
					this.fileId = item.fileId
				}
			})
			this.total = res.data.total
		} else {
			this.$message.error(res.data.msg)
		}
	},
	showDetail(item,index){
		this.taskDesc = ''
		this.fileUrl = ''
		this.fileId = ''
		this.currentIndex = index
		if(item.enrollStatus==4) {
			this.taskDesc = item.enrollContent
			// this.fileUrl = item.fileUrl
			this.fileId = item.fileId
		}
	},
	//获取任务规则弹窗
	async getTaskRules(){
		let url = 'v1/activityTask/getTaskCategory'
		let code = ''
		if(this.codeId==1) {
			code = 'XUANSHANG'
		} else if(this.codeId==2) {
			code = 'CESHI'
		} else if(this.codeId==3){
			code = 'SHIPEI'
		}
		let param = {
			code: code
		}
		ajaxParam(param)
		const res = await post(url, qs.stringify(param))
		if(res.data.code==200) {
			if(res.data.entity){
				this.ruleContent = res.data.entity.ruleContent
			}
		} else {
			this.$message.error(res.data.msg)
		}
	},
	//领取任务
	async getTask(item){
		if(!this.userId){
			this.$router.push('/login')
			return
		}
		let url = 'v1/activityTask/receiveTask'
		let param = {
			activityId: this.activityId,
			userId: this.userId,
			taskId: item.id
		}
		ajaxParam(param)
		const res = await post(url, qs.stringify(param))
		if(res.data.code==200) {
			this.getTaskDialog = true
			item.enrollStatus = res.data.status
		} else {
			this.$message.error(res.data.msg)
		}
	},
	//提交任务
	async submitTask(item){
		if(this.fileId.length<=0){
			this.$message.error('请上传附件！')
			return false
		}
		let url = 'v1/activityTask/submitTask'
		let param = {
			userId: this.userId,
			taskId: item.id,
			// fileUrl: this.fileUrl,
			fileId: this.fileId
		}
		ajaxParam(param)
		const res = await post(url, qs.stringify(param))
		if(res.data.code==200) {
			this.submitTaskDailog = true
			item.enrollStatus = res.data.status
			item.enrollContent = res.data.enrollContent
			if(item.answerType==1){
				//单次任务
				// item.fileUrl = res.data.fileUrl
        item.fileId = res.data.fileId
				item.fileName = res.data.fileName
			} else if(item.answerType==2) {
				//多次任务
				item.fileList = res.data.fileList
				item.enrollId = res.data.enrollId
			}
			this.uploadFileList = []
			this.fileUrl = ''
			this.fileId = ''
		} else {
			this.$message.error(res.data.msg)
		}
	},
	//再次提交任务
	async submitTaskAgain(item){
		if(this.fileId.length<=0){
			this.$message.error('请上传附件！')
			return false
		}
		let url = 'v1/activityTask/addTaskFile'
		let param = {
			userId: this.userId,
			enrollId: item.enrollId,
			// fileUrl: this.fileUrl,
			fileId: this.fileId
		}
		ajaxParam(param)
		const res = await post(url, qs.stringify(param))
		if(res.data.code==200) {
			this.submitTaskDailog = true
			item.enrollStatus = res.data.status
			item.fileList = res.data.fileList
			this.uploadFileList = []
			this.fileUrl = ''
			this.fileId = ''
		} else {
			this.$message.error(res.data.msg)
		}
	},
	//撤销任务
	revokeTask(item,index){
		this.$confirm('确定要撤销该任务？','温馨提示',{
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(async()=>{
			let url = 'v1/activityTask/revokeTask'
			let param = {
				userId: this.userId,
				taskId: item.id
			}
			ajaxParam(param)
			const res = await post(url, qs.stringify(param))
			if(res.data.code==200) {
				// this.submitTaskDailog = true
				this.$message.success('您的任务撤销成功！')
				item.enrollStatus = '2'
				this.dataList.splice(index,1,item)
				this.taskDesc = ''
				this.fileUrl = ''
			} else {
				this.$message.error(res.data.msg)
			}
		}).catch(()=>{

		})
	},
	//审核中弹窗
	checking(){
		this.checkingDialog= true
	},
	//上传附件成功
	handleSuccess(res){
		// this.uploadFileList.push({
		// 	fileName: res.entity.fileName,
		// 	fileUrl: res.entity.fileUrl
		// })
		// this.fileUrl = res.entity.fileUrl
		this.fileId  = res.entity.id

	},
	//删除上传附件
	handleRemove(){
		this.fileUrl = ''
		this.fileId =''
	},
	//上传附近失败
	handleError(){
	},
	handlePreview(file){
		//window.location.href = file.response.entity.fileUrl
		// window.open(file.response.entity.fileUrl)
    this.getFile(file.response.entity.id);
		// this.isProcess = true
		// this.videoUploadPercent = file.percentage.toFixed(0);
	},
	//文件超出个数限制
	handleExceed(){
		this.$message.warning('最多传一个文件！')
	},
	closeDialog(type){
		if(type=='submitTaskDailog') {
			this.submitTaskDailog = false
		}
		if(type=='getTaskDialog') {
			this.getTaskDialog = false
		}
		if(type=='checkingDialog'){
			this.checkingDialog = false
		}
		if(type=='dialogVisible'){
			this.dialogVisible = false
		}
	},
	changeRadioDialog(e){
		if(this.codeId==1){
			e == this.radioDialog1 ? this.radioDialog1 = '' : this.radioDialog1 = e
			localStorage.setItem('radioDialog1', this.radioDialog1)
			// if(this.radioDialog1==10) {
			// 	localStorage.setItem('radioDialog1', this.radioDialog1)
			// }
		}
		if(this.codeId==2){
			e == this.radioDialog2 ? this.radioDialog2 = '' : this.radioDialog2 = e
			localStorage.setItem('radioDialog2', this.radioDialog2)
		}
		if(this.codeId==3){
			e == this.radioDialog3 ? this.radioDialog3 = '' : this.radioDialog3 = e
			localStorage.setItem('radioDialog3', this.radioDialog3)
		}
	},
	handleCurrentChange(e){
		this.dataList = []
		this.pageNum = e
		this.currentIndex = -1
		this.getDataList()
	},
	deleteFile(item){
		item.fileUrl = ''
    item.fileId = ''
	},
	//获取当前活动信息
	async getActiveInfo(){
		let url = 'v1/activity/getIndexActivity'
		let param = {}
		const res = await post(url, param)
		if(res.data.code==200) {
			let entity = res.data.entity
			this.attachTask = entity.attachTask
			this.attachTest = entity.attachTest
			this.attachAdaptation = entity.attachAdaptation
			this.activityId = entity.id
		} else {
			this.$message.error(res.data.msg)
		}
	},

    //获取文件
    async getFile(id){
      let url = 'v1/file/download/'+id
      window.location.href = config.baseUrl + url;

      // let param = {}
      // const res = await post(url, param)
      // const link=document.createElement("a");
      // // let blob=new Blob([res.data], { type: "application/vnd.ms-excel" });
      // link.style.display="none";
      // link.href=res.data;
      // document.body.appendChild(link);
      // link.click();
      // document.body.removeChild(link);
    },



    beforeUpload(file){
		const fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1)
		const whiteList = ['doc', 'docx', 'wps', 'xls', 'xlsx', 'txt', 'rtf', 'pdf', 'bmp', 'gif', 'jpg', 'pic', 'png', 'tif', 'rar', 'zip', 'arj', 'gz', 'z']
		if (whiteList.indexOf(fileSuffix) == -1) {
			this.$message.error("附件格式不符合要求")
			return false
		}
	}
  },
  created(){
	this.userId = localStorage.getItem('userId')
	this.activityId = localStorage.getItem('activityId')
	// this.attachTask = localStorage.getItem('attachTask')
	// this.attachTest = localStorage.getItem('attachTest')
	// this.attachAdaptation = localStorage.getItem('attachAdaptation')
	this.codeId = this.$route.params.id
	this.radioDialog1 = localStorage.getItem('radioDialog1')
	this.radioDialog2 = localStorage.getItem('radioDialog2')
	this.radioDialog3 = localStorage.getItem('radioDialog3')
	this.uploadUrl = config.baseUrl + 'v1/upload/resInside'
	if(this.radioDialog1==10&&this.codeId==1){
		this.dialogVisible = false
	}
	if(this.radioDialog2==10&&this.codeId==2){
		this.dialogVisible = false
	}
	if(this.radioDialog3==10&&this.codeId==3){
		this.dialogVisible = false
	}
	this.getActiveInfo()
	this.getDataList()
	this.getTaskRules()
  },
  watch: {
	$route(){
		this.codeId = this.$route.params.id
		this.dialogVisible = true
		this.radioDialog1 = localStorage.getItem('radioDialog1')
		this.radioDialog2 = localStorage.getItem('radioDialog2')
		this.radioDialog3 = localStorage.getItem('radioDialog3')
		if(this.radioDialog1==10&&this.codeId==1){
			this.dialogVisible = false
		}
		if(this.radioDialog2==10&&this.codeId==2){
			this.dialogVisible = false
		}
		if(this.radioDialog3==10&&this.codeId==3){
			this.dialogVisible = false
		}
		this.currentIndex = -1
		//this.dialogVisible = true
		this.getDataList()
		this.getTaskRules()
	}
  }
}
</script>

<style scoped>
.task-active .task-title{margin-bottom: 0!important; background: #DE0515; color:#fff;}
.task-active .task-status span{color:#DE0515}
.el-dialog__body .btns-single{margin: 20px auto 0!important; width: 180px; height: 36px; line-height: 36px; font-size: 18px;}
.rule-tips{display: flex; justify-content: center; padding: 30px 0 0; font-size: 12px;}
.el-radio__label, .el-checkbox__label {
    font-size: 12px!important;
}
 .task-guide{position:relative;}
/*下载模板*/
.down-list{margin-bottom: 20px;}
.down-list li{float:left; width:28.9%; margin-right:6.65%}
.down-list li:last-of-type{margin-right: 0;}
.down-list li img{width:100%;}
/*排序*/
.sort-wrap{display: flex; justify-content: flex-end; padding-bottom: 20px; font-size: 14px;}
.sort-wrap h6{margin-right:20px; font-size: 16px;}
.sort-item{display: flex; align-items:center; color:#bebebe}
.sort-line{display: block; width:1px; height:15px; margin:0 10px; background: #C0C0C0; }
.sort-item span{cursor: pointer;}
.sort-item-active{color:#000}

.upload-demo{display: inline; float:left}
.upload-demo span:nth-of-type(1){margin-right:0}
.task-total-score{font-weight: bold; font-size: 20px; display: flex; justify-content: flex-end; background:#f4f4f4; padding: 20px 35px 0;}
.task-total-score span{padding-left:10px}

.btns-two .upload-demo {float: none;}
.el-radio__input .el-radio__inner,.el-radio__input.is-checked .el-radio__inner {
	box-shadow: none !important;
}
.dialog-wrap{margin-top: -20rpx}
.dialog-wrap p{padding-bottom: 5px;}
</style>
